export function enrichTimeEntryListRow(entry: any) {
  return {
    ...entry,
    ticket_number: entry.ticket?.ticket_number,
    ticket_title: entry.ticket?.title,
    user_email: entry.user?.email,
    user_name:
      entry.user?.first_name || entry.user?.last_name
        ? `${entry.user?.first_name || ""} ${entry.user?.last_name || ""}`.trim()
        : entry.user?.email,
    contact_name:
      entry.ticket?.contact?.company_name ||
      entry.ticket?.contact?.name ||
      (entry.ticket ? "Unknown Contact" : "No Ticket"),
    contact_email: entry.ticket?.contact?.email || null,
    client_name:
      entry.ticket?.contact?.company_name ||
      entry.ticket?.contact?.name ||
      (entry.ticket ? "Unknown Contact" : "No Ticket"),
    client_email: entry.ticket?.contact?.email || null,
  };
}

export function enrichTimeEntryApprovalRow(entry: any) {
  return {
    ...entry,
    ticket_number: entry.ticket?.ticket_number,
    ticket_title: entry.ticket?.title,
    ticket_priority: entry.ticket?.priority,
    ticket_status: entry.ticket?.status,
    user_email: entry.user?.email,
    user_name:
      entry.user?.first_name || entry.user?.last_name
        ? `${entry.user?.first_name || ""} ${entry.user?.last_name || ""}`.trim()
        : entry.user?.email,
  };
}
